<script setup lang="ts">
import {ref} from 'vue';
import {FloatingPanel, Panel} from '@hantera/design-system';
import ListPatView from "@/views/Pat/ListPatView.vue";
import CreatePatView from "@/views/Pat/CreatePatView.vue";

const accessTokenModal = ref<typeof FloatingPanel>();
const accessToken = ref();

const state = ref<{
  type: 'list'
} | {
  type: 'new'
}>({ type: 'list' });

function showPat(token: string) {
  accessToken.value = token;
  accessTokenModal.value?.open();
}

function clearToken() {
  accessToken.value = '';
}

function copyToken() {
  navigator.clipboard.writeText(accessToken.value);
}

function createNew() {
  state.value.type = 'new'
}

function showList() {
  state.value.type = 'list'
}

function created(accessToken: string) {
  state.value.type = 'list'
  showPat(accessToken)
}

</script>

<template>

  <Panel :isRoot="true" class="pat-view">

    <div class="pat-view__container">

      <ListPatView v-if="state.type == 'list'" @create-new="createNew" />
      <CreatePatView v-if="state.type == 'new'" @cancelled="showList" @created="created" />
      
    </div>

  </Panel>

  <FloatingPanel label="Personal Access Token" ref="accessTokenModal" :showClose="true" @close="clearToken()">
    <p>Your personal access token has been created. Please copy it and store it in a safe place. You will not be able to see it again.</p>
    <p><strong>Token:</strong> <code class="access-token">{{ accessToken }}</code></p>
    <button class="btn-primary" @click="copyToken()">Copy</button>
  </FloatingPanel>

</template>

<style scoped>
.access-token {
  user-select: all;
}
</style>

<style>
.pat-view {
  height: 100%;
  overflow: auto;
}

.pat-view__container {
  margin: auto;
  max-width: 800px;
  padding-top: 3rem;
  padding-bottom: 3rem;
}
</style>